import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import Swal from 'sweetalert2';
import { Perspectivas, Indicadores } from '../../../models/Formulacion/indicadores-metas/datos';
import { IMG } from '../../../services/imagen/png';
import { CuadromandoService } from '../../../services/formulacion/cuadro-mando-integral/cuadromando.service';
import { messages } from '../../funciones/mensajes';
import { firstValueFrom } from 'rxjs';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { IndicadorService } from '../../../services/gestion/indicadores/indicador.service';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-cuadro-mando-integral',
  templateUrl: './cuadro-mando-integral.component.html',
  styleUrl: './cuadro-mando-integral.component.css'
})
export class CuadroMandoIntegralComponent {
  public mision;
  public vision;
  public nombreObj = '';
  public tarjOrTab = true;
  public diccionarioPerspectivas: any = [];
  private idPlanificacion: any;
  public perspectivas = [];
  public indicadores: Indicadores[] = [];
  public perspectivaSel = '';
  public numeroPer = 0;

  constructor(
    public dataService: DataService,
    private cookieService: CookieService,
    private excelService: ExcelService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private objetivosService: ObjetivoService,
    private indicadorService: IndicadorService
  ) {
    this.obtData();
  }
  private ordenamientoPer(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private async obtData(){
    try{
      this.idPlanificacion = Number(this.cookieService.get('idInstitucion'));
      const plan = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion);
      const fil = this.ordenamientoPer([].concat(plan.philosophies));
      for(var i = 0; i <= fil.length-1; i++){
        if(i === 0){
          this.mision = fil[i];
        }else if(i === 1){
          this.vision = fil[i];
        }else{
          break;
        }
      } 
      this.perspectivas = [];
      for (const per of plan.perspectives){
        this.perspectivas.push({
          nombre: per.name,
          descripcion: per.descripcion,
          planningId: this.idPlanificacion,
          id: per.id,
          check: true,
          objetivos: [],
        });
      }
      this.perspectivas = this.ordenamientoPer(this.perspectivas);
      this.perspectivas.forEach(per => { this.diccionarioPerspectivas.push({perspectiva: per, objetivos : []}); });
      var indicators = [];
      for(const per of this.diccionarioPerspectivas){
        const obj = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.perspectiva.id))
        for(const o of obj){
          var ind = [];
          per.objetivos.push({
            nombre: o.name,
            descripcion: o.description, 
            ponderacion: o.weighing, 
            perspectiveId: per.perspectiva.id, 
            id: o.id,
            indicators: ind,
          });
        }
      }

      this.obtenerIndicadores();
    }catch(err){
      messages.errorMessageGraph(err);
    }

  }
  private async obtenerIndicadores(){
    try{
      for(const per of this.diccionarioPerspectivas){
        for(const obj of per.objetivos){
          const res = await this.indicadorService.getIndicadoresByObjetiveGQL(Number(obj.id));
          if(res.length !== 0){
            obj.indicators = res;
          }else{
            obj.indicators.push({
              name: "",
              weighing: ""
            });
          }
        }
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }    
  }
  public color(indice: any){
    switch(indice){
      case 0: return 'cuadroP1';
      case 1: return 'cuadroP2';
      case 2: return 'cuadroP3';
      case 3: return 'cuadroP4';
      case 4: return 'cuadroP5';
      case 5: return 'cuadroP6';
      case 6: return 'cuadroP7';
      case 7: return 'cuadroP8';
      case 8: return 'cuadroP9';
    }
    return ''
  }

  public async modal_ind(obj: any, per: any, number: any){
    this.perspectivaSel = per;
    this.numeroPer = number;
    this.nombreObj = obj.nombre;
    try{
      const res = await this.indicadorService.getIndicadoresByObjetiveGQL(obj.id); 
      this.indicadores = [];
      for(const ind of res){
          this.indicadores.push({
            nombre: ind.name,
          });
      }
      this.indicadores = this.ordenamientoPer(this.indicadores);
      var html = '<div class="w3-row">'+
      '<div class="w3-row">'+
      '  <div style="text-align: justify; margin-left: 1vw; margin-right: 2vw;"> Indicadores asociados </div>'+
      '</div>'+
      '<mat-list style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">';

      for(const ind of this.indicadores){
        html += '<div mat-line style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">'+
        '<span style="color: #ff6b00">&#8226;</span>'+
        ' '+ind.nombre+
        '</div>';
      }
      html += '</mat-list>'+'</div>';

      var ancho = 'auto';
      if(this.nombreObj.length >100){
        ancho = '60%'
      }

      Swal.fire({
        title: 'Objetivo'+  this.obtLet(this.perspectivaSel)+(this.numeroPer+1)+': '+ this.nombreObj,
        html: html,
        showConfirmButton: false,
        width: ancho+'',
      });
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  public obtLet(per: any){
    return ''+per.perspectiva.nombre[0];
  }

  public async imprimirImg(){
    messages.messageSaving(this.translate.instant('swal.generandoImg'),this.translate.instant('swal.espere'))
    const grafica = 'img-1';
    const name = 'CMI';
    const element = document.getElementById(grafica);
    const clone = element.cloneNode(true) as HTMLElement;

    clone.style.position = 'absolute';
    clone.style.left = '0';
    clone.style.top = '0';
    clone.style.transform = 'translateX(-10000px)';

    clone.style.height = 'auto';
    clone.style.maxHeight = 'none';
    clone.style.overflow = 'visible';

    clone.style.padding = '20px';
    clone.style.background = '#ffffff';
    clone.style.boxSizing = 'border-box';

    document.body.appendChild(clone);

    const canvas = await html2canvas(clone, {
        backgroundColor: '#ffffff',
        scale: window.devicePixelRatio,
        useCORS: true,
        logging: false
    });
    const link = document.createElement('a');
    link.download = `${name}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();

    document.body.removeChild(clone);
    Swal.close();
  }
  public exportarTab(){
    const title = 'Cuadro mando integral';
    var header = [
      this.translate.instant('gestion.formulacion.cuadro-mando.titTab1'), 
      this.translate.instant('gestion.formulacion.cuadro-mando.titTab2'), 
      this.translate.instant('gestion.formulacion.cuadro-mando.titTab4'), 
      this.translate.instant('gestion.formulacion.cuadro-mando.titTab3'), 
      this.translate.instant('gestion.formulacion.cuadro-mando.titTab4'), 
    ];
    var data = [];
    var aux = [];
    for(const per of this.diccionarioPerspectivas){
      for(var i = 0; i <= per.objetivos.length-1; i++){
        for(var j = 0; j <= per.objetivos[i].indicators.length-1; j++){
          aux.push( i===0&&j===0?per.perspectiva.nombre:'' );
          aux.push( j===0?per.objetivos[i].nombre:'' );
          aux.push( j===0?per.objetivos[i].ponderacion:'' );
          aux.push( per.objetivos[i].indicators[j].name );
          aux.push( per.objetivos[i].indicators[j].weighing );
          data.push(aux);
          aux = [];
        }
      }
    }
    const NomArch = 'Cuadro mando integral';
    this.excelService.generateExcelCMIFormulacion(title, header, data, NomArch);
  }

}
